import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const STORAGE_KEY = 'cc-show-section-guidance';

function readStoredVisible() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === '0' || v === 'false') return false;
    return true;
  } catch {
    return true;
  }
}

const SectionGuidanceVisibilityContext = createContext(null);

export function SectionGuidanceVisibilityProvider({ children }) {
  const [isGuidanceVisible, setVisibleState] = useState(readStoredVisible);

  const setIsGuidanceVisible = useCallback((next) => {
    const on = typeof next === 'boolean' ? next : Boolean(next);
    setVisibleState(on);
    try {
      localStorage.setItem(STORAGE_KEY, on ? '1' : '0');
    } catch {
      /* ignore private mode / quota */
    }
  }, []);

  const value = useMemo(
    () => ({ isGuidanceVisible, setIsGuidanceVisible, hasProvider: true }),
    [isGuidanceVisible, setIsGuidanceVisible],
  );

  return (
    <SectionGuidanceVisibilityContext.Provider value={value}>
      {children}
    </SectionGuidanceVisibilityContext.Provider>
  );
}

/** @returns {{ isGuidanceVisible: boolean, setIsGuidanceVisible: (v: boolean) => void, hasProvider: true } | null} */
export function useSectionGuidanceVisibility() {
  return useContext(SectionGuidanceVisibilityContext);
}
